export const SET_INDEX = 'SET_INDEX';
export const SET_BUNDLES = 'SET_BUNDLES';
export const SET_OPTIONS = 'SET_OPTIONS';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_SELECTED_OPTIONS = 'SET_SELECTED_OPTIONS';
export const SET_DEFAULT_PRESETS = 'SET_DEFAULT_PRESETS';
export const SET_ACTIVE_BUNDLE_ID = 'SET_ACTIVE_BUNDLE_ID';
export const SET_ACTIVE_TAB_ID = 'SET_ACTIVE_TAB_ID';
export const SET_AVERAGE_WAIT_TIME = 'SET_AVERAGE_WAIT_TIME';
export const SET_STREAM_STORE = 'SET_STREAM_STORE';
export const SET_SESSION_ID = 'SET_SESSION_ID';
export const SET_QUEUE_DATA = 'SET_QUEUE_DATA';
export const SET_PRODUCT_DETAILS = 'SET_PRODUCT_DETAILS';
export const SET_CONNECTION_STATUS = 'SET_CONNECTION_STATUS';
export const TOGGLE_STREAM = 'TOGGLE_STREAM';
export const TOGGLE_CONFIGURATION_PORTAL = 'TOGGLE_CONFIGURATION_PORTAL';
export const TOGGLE_PRODUCT_PORTAL = 'TOGGLE_PRODUCT_PORTAL';
export const TOGGLE_INTERACTIONS_PORTAL = 'TOGGLE_INTERACTIONS_PORTAL';
export const TOGGLE_STICKY_PANEL = 'TOGGLE_STICKY_PANEL';
export const TOGGLE_PRODUCT_DETAILS = 'TOGGLE_PRODUCT_DETAILS';

export default function appReducer(state, {type, payload}) {
	switch (type) {
		case SET_STREAM_STORE:
			return {
				...state,
				streamStore: {
					...state.streamStore,
					...payload,
				},
			};
		case SET_CONNECTION_STATUS:
			return {
				...state,
				connectionStatus: payload,
			};
		case SET_QUEUE_DATA:
			return {
				...state,
				queueData: {
					...state.queueData,
					...payload,
				},
			};
		case SET_SESSION_ID:
			return {
				...state,
				sessionId: payload,
			};
		case TOGGLE_STREAM:
			return {
				...state,
				isAllowStream: payload,
			};
		case SET_BUNDLES:
			return {
				...state,
				bundles: payload,
			};
		case SET_OPTIONS:
			return {
				...state,
				options: payload,
			}
		case SET_SELECTED_OPTIONS:
			return {
				...state,
				selectedOptions: payload,
			}
		case SET_PRODUCTS:
			return {
				...state,
				products: payload,
			}
		case SET_DEFAULT_PRESETS:
			return {
				...state,
				defaultPresets: payload,
			}
		case SET_PRODUCT_DETAILS:
			return {
				...state,
				productDetailsId: payload,
			}
		case SET_ACTIVE_BUNDLE_ID:
			return {
				...state,
				activeBundleId: payload,
			}
		case SET_ACTIVE_TAB_ID:
			return {
				...state,
				activeTabId: payload,
			}
		case TOGGLE_CONFIGURATION_PORTAL:
			return {
				...state,
				isConfiguratorPortalOpen: payload,
			}
		case TOGGLE_PRODUCT_PORTAL:
			return {
				...state,
				isProductPortalOpen: payload,
			}
		case TOGGLE_INTERACTIONS_PORTAL:
			return {
				...state,
				isInteractionsPortalOpen: payload,
			}
		case TOGGLE_STICKY_PANEL:
			return {
				...state,
				isStickyPanelCollapsed: payload,
			}
		case TOGGLE_PRODUCT_DETAILS:
			return {
				...state,
				isProductDetailsOpen: payload,
			}
		default:
			break;
	}
}
